import { store } from "../../redux/store";
import Login from "../../views/signIn/login";
import Register from "../../views/signIn/register";
import ResetPassword from "../../views/pages/account/resetPassword";
import Verify from "../../views/pages/account/verify";
import ForgotPassword from "../../views/pages/account/forgotPassword";
import Home from "../../views/pages/home/home";
import Tests from "../../views/pages/box/tests/tests";
import Subscription from "../../views/pages/subscription/subscription";
import SubscriptionCompleted from "../../views/pages/subscription/subscriptionCompleted";
import CreateTest from "../../views/pages/box/tests/createTest";
import CreateFlashcard from "../../views/pages/box/flashcards/createFlashcard";
import ErrorPage from "../../views/pages/errors/error.js";
import VerifyEmail from "../../views/pages/account/verifyMessage";
import AccountingTest from "../../views/pages/box/tests/accountingTest";
import AccountingFlashcard from "../../views/pages/box/flashcards/accountingFlashcard";
import ResultTest from "../../views/pages/box/tests/resultTest";
import ResultFlashcard from "../../views/pages/box/flashcards/resultFlashcard";
import Settings from "../../views/pages/main_settings/main_settings";
import NoteDetail from "../../views/pages/box/notes/noteDetail";
import CreateNote from "../../views/pages/box/notes/createNote";
import ResultWrittenTest from "../../views/pages/box/tests/resultWrittenTest";
import Flashcards from "../../views/pages/box/flashcards/flashcards";
import QuizLog from "../../views/pages/quizLog/quizLog";
import Courses from "../../views/pages/cources/cources";
import CreateCourse from "../../views/pages/cources/createCourse";
import CourseDetails from "../../views/pages/cources/courseDetails";
import Invite from "../../views/pages/invite/invite.js";
import ResultView from "../../views/pages/box/tests/resultView";
import ResultViewWritten from "../../views/pages/box/tests/resultViewWritten";
import Result from "../../views/pages/box/tests/result";
import Answers from "../../views/pages/box/tests/answers";
import AnswerQuestions from "../../views/pages/box/tests/answerQuestions";
import CompleteTest from "../../views/pages/box/tests/completeTest";
import AnonymousTest from "../../views/pages/box/tests/anonymousTest";
import AnonymousResult from "../../views/pages/box/tests/anonymousResult";
import AnonymousResultWritten from "../../views/pages/box/tests/anonymousResultWritten";
import CourseStudents from "../../views/pages/cources/courseStudents.js";
import { useEffect } from "react";
import Tryforfree from "../../views/pages/otherPages/tryforfree.js";
import FlashcardTest from "../../views/pages/otherPages/tryforfreeComponents/flashcards.js";
import ResultTryForFreeFlashcard from "../../views/pages/otherPages/tryforfreeComponents/resultFlashcard.js";
import FreeTest from "../../views/pages/otherPages/tryforfreeComponents/tests.js";
import ResultFreeTest from "../../views/pages/otherPages/tryforfreeComponents/resultTest.js";
import ResultFreeWrittenTest from "../../views/pages/otherPages/tryforfreeComponents/resultFreeWrittenTest.js";
import TestWithGPT from "../../views/pages/gpt/testWithGPT.js";
import Prompt from "../../views/pages/gpt/prompt.js";
// ** Document title
const TemplateTitle = "%s - Account Template";
// const getPlain = localStorage.getItem("encriptedJson");

const accesToken = store.getState().auth.userData.access_token;

const getDefoultRoute = function getDefoultRoute(accesToken) {
    return accesToken ? "/home" : "/login";
};

// ** Merge Routes
const Routes = [
    {
        path: "/login",
        component: Login,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/tryforfree",
        component: Tryforfree,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/flashcardTest",
        component: FlashcardTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/freeTest",
        component: FreeTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/resultFreeTest",
        component: ResultFreeTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/resultFreeWrittrnTest",
        component: ResultFreeWrittenTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/resultTryForFreeFlashcard",
        component: ResultTryForFreeFlashcard,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/resultView",
        component: ResultView,
    },
    {
        path: "/courses",
        component: Courses,
    },
    {
        path: "/completeTest",
        component: CompleteTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/invite",
        component: Invite,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/invateUser",
        component: Invite,
    },
    {
        path: "/answers",
        component: Answers,
    },
    {
        path: "/answerQuestions",
        component: AnswerQuestions,
    },
    {
        path: "/courseDetails",
        component: CourseDetails,
    },
    {
        path: "/courseStudents",
        component: CourseStudents,
    },
    {
        path: "/createCourse",
        component: CreateCourse,
    },
    {
        path: "/resetPassword",
        component: ResetPassword,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/verifyEmail",
        component: VerifyEmail,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/verify",
        component: Verify,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/forgotPassword",
        component: ForgotPassword,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },

    {
        path: "/register",
        component: Register,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },

    {
        path: "/home",
        component: Home,
    },
    {
        path: "/quizLog",
        component: QuizLog,
    },
    {
        path: "/flashcards",
        component: Flashcards,
    },
    {
        path: "/settings",
        component: Settings,
    },
    {
        path: "/subscriptionCompleted/:token",
        component: SubscriptionCompleted,
    },

    {
        path: "/subscription",
        component: Subscription,
    },
    {
        path: "/note",
        component: NoteDetail,
    },
    {
        path: "/tests",
        component: Tests,
    },

    {
        path: "/createTest",
        component: CreateTest,
    },
    {
        path: "/createNote",
        component: CreateNote,
    },
    {
        path: "/createFlashcard",
        component: CreateFlashcard,
    },
    {
        path: "/accountingTest",
        component: AccountingTest,
    },
    {
        path: "/testProcess",
        component: AnonymousTest,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/anonymousResultWritten",
        component: AnonymousResultWritten,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/anonymousResult",
        component: AnonymousResult,
        layout: "BlankLayout",
        meta: {
            authRoute: true,
        },
    },
    {
        path: "/accountingFlashcard",
        component: AccountingFlashcard,
    },
    {
        path: "/resultTest",
        component: ResultTest,
    },
    {
        path: "/result",
        component: Result,
    },
    {
        path: "/resultWrittenTest",
        component: ResultWrittenTest,
    },
    {
        path: "/resultViewWritten",
        component: ResultViewWritten,
    },
    {
        path: "/resultFlashcard",
        component: ResultFlashcard,
    },

    {
        path: "/error",
        component: ErrorPage,
        layout: "BlankLayout",
    },

    {
        path: "/testWithGPT_b6f02e5f-004d-4263-ae8b-5afd13bcbe27",
        component: TestWithGPT,
    },
    {
        path: "/prompt_dsfg5f-dfgd-4263-ae8b",
        component: Prompt,
    },
];

export { TemplateTitle, Routes, getDefoultRoute };
